import * as React from 'react';

import CareerDetailContainer from '../../containers/CareerDetail';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 研修詳細情報画面
 * @param props
 */
const CareerDetail: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('CareerDetail_0041')} />
			<CareerDetailContainer {...props} />
		</>
	);
};

export default CareerDetail;



// WEBPACK FOOTER //
// ./src/pages/personal/CareerDetail.tsx